export class RegisterCriteria {
	comCode: string;
	firstName?: string;
	lastName?: string;
	email: string;
	confirmedEmail: string;
	dateOfBirth: string;
	last4SSN: string;
	zipCode: string;
	systemNumber: number;
	verificationPhoneNumber?: string;
	phoneNumber?: string;
	verificationType?: string;
	reCaptchaToken?: string;
	isPortal: boolean;
	iD: number;

	constructor() {
		this.comCode = '';
		this.firstName = '';
		this.lastName = '';
		this.email = '';
		this.confirmedEmail = '';
		this.dateOfBirth = '';
		this.last4SSN = '';
		this.zipCode = '';
		this.verificationPhoneNumber = null;
		this.phoneNumber = null;
		this.verificationType = null;
		this.systemNumber = 0;
		this.reCaptchaToken = null;
		this.isPortal = true;
		this.iD = 0;
	}
}
